import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Bullets, Paragraph, SectionHeading, SubHeading } from './_shared/Prose'

/**
 * Seção 3 - Objetivo. Texto literal do modelo aprovado por Julia Buzzo ("Modelo PGR
 * 2026 - Banco Bradesco_Varejo"). Substitui o placeholder institucional anterior
 * (arquivo era `03.AbrangenciaSection.js` — não há seção "Abrangência" no modelo real).
 */
const ObjetivoSection = () => (
  <View id="3">
    <Separator weight={15} />
    <SectionHeading numero={3}>OBJETIVO</SectionHeading>

    <Paragraph>
      O Programa de Gerenciamento de Riscos (PGR) tem como objetivo principal a preservação da saúde e da integridade
      física e mental dos trabalhadores, por meio da identificação dos perigos, avaliação dos riscos ocupacionais –
      incluindo os fatores psicossociais, e da classificação desses riscos conforme o nível de severidade e
      probabilidade, a fim de subsidiar a adoção de medidas de prevenção conforme a ordem de prioridade estabelecida
      no subitem 1.4.1, alínea "g" da NR-1.
    </Paragraph>

    <SubHeading id="3.1">3.1. Objetivos específicos do Inventário de Riscos Ocupacionais:</SubHeading>
    <Bullets
      items={[
        'Identificar e caracterizar todas as exposições relacionadas a condições perigosas e a agentes potencialmente nocivos, como agentes químicos, físicos, biológicos, ergonômicos incluindo os fatores de riscos psicossociais relacionados ao trabalho, além de outros fatores estressores que representem sobrecarga de trabalho.',
        'Caracterizar a intensidade, frequência e variação temporal das exposições, abrangendo todos os trabalhadores próprios nas unidades da organização.',
        'Avaliar os riscos à segurança, saúde física e saúde mental dos trabalhadores, considerando inclusive os aspectos organizacionais e psicossociais do trabalho.',
        'Priorizar e recomendar ações preventivas e corretivas para exposições que representem riscos inaceitáveis ou intoleráveis, segundo critérios legais e técnicos.',
        'Registrar e documentar as avaliações ambientais e organizacionais realizadas no ambiente laboral, compondo a base técnica do plano de ação.',
        'Promover a cultura de prevenção, com campanhas e informativos de saúde geral e ocupacional.',
        'Manter registros históricos das exposições ocupacionais, de forma a permitir a rastreabilidade e o gerenciamento de possíveis impactos futuros na saúde dos trabalhadores com base em dados reais de exposição.'
      ]}
    />

    <Paragraph>
      Com essa abordagem, o PGR se consolida como uma ferramenta estratégica e integrada à gestão de SST, alinhada
      com os novos requisitos da NR-1 e com foco na promoção da saúde integral, bem-estar e sustentabilidade das
      relações de trabalho.
    </Paragraph>

    <Separator weight={15} />
  </View>
)

export default ObjetivoSection
